"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchOptionListQuery = exports.useEditOptionMutation = exports.useLazyOptionByKeyQuery = exports.useLazyOptionByIdQuery = exports.useGetOptionListQuery = exports.OptionApi = void 0;
exports.useOptionFromLocation = useOptionFromLocation;
exports.useOptionFromLocationKey = useOptionFromLocationKey;
const react_1 = require("@reduxjs/toolkit/query/react");
const Utils_1 = require("../../Utils");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const http_1 = require("../../http");
const user_api_1 = require("../user/user.api");
exports.OptionApi = (0, react_1.createApi)({
    reducerPath: "optionApi",
    tagTypes: ["options", "optionById", "optionByKey", "optionList"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: user_api_1.prepareHeaders,
    }),
    endpoints: (builder) => ({
        getOptionList: builder.query({
            query: () => `options/`,
            providesTags: ["options", "optionById", "optionList"],
        }),
        optionById: builder.query({
            query: (id) => `options/${id}/`,
            providesTags: ["optionById"],
        }),
        optionByKey: builder.query({
            query: (id) => `option-key/${id}/`,
            providesTags: ["optionByKey"],
        }),
        editOption: builder.mutation({
            invalidatesTags: ["options", "optionById", "optionList"],
            query: ({ id, data }) => ({
                url: `options/${id}/`,
                method: "POST",
                body: data,
            }),
        }),
        fetchOptionList: builder.query({
            query: () => `options/`,
            providesTags: ["options", "optionById", "optionList"],
        }),
    })
});
exports.useGetOptionListQuery = exports.OptionApi.useGetOptionListQuery, exports.useLazyOptionByIdQuery = exports.OptionApi.useLazyOptionByIdQuery, exports.useLazyOptionByKeyQuery = exports.OptionApi.useLazyOptionByKeyQuery, exports.useEditOptionMutation = exports.OptionApi.useEditOptionMutation, exports.useFetchOptionListQuery = exports.OptionApi.useFetchOptionListQuery;
function useOptionFromLocation() {
    const itemState = (0, Utils_1.useLocationState)(undefined);
    const [item, setItem] = (0, react_2.useState)(itemState);
    const { id } = (0, react_router_dom_1.useParams)();
    const [findById, { data, isError, isLoading }] = (0, exports.useLazyOptionByIdQuery)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_2.useEffect)(() => {
        if (id) {
            findById(id);
        }
    }, [id]);
    (0, react_2.useEffect)(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    (0, react_2.useEffect)(() => {
        if (data) {
            if (data === null || data === void 0 ? void 0 : data.success) {
                setItem(data === null || data === void 0 ? void 0 : data.data);
            }
            else {
                navigate(-1);
            }
        }
    }, [data]);
    return [item, isLoading, id, findById];
}
function useOptionFromLocationKey() {
    const itemState = (0, Utils_1.useLocationState)(undefined);
    const [item, setItem] = (0, react_2.useState)(itemState);
    const { id } = (0, react_router_dom_1.useParams)();
    const [findByKey, { data, isError, isLoading }] = (0, exports.useLazyOptionByKeyQuery)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_2.useEffect)(() => {
        if (id) {
            findByKey(id);
        }
    }, [id]);
    (0, react_2.useEffect)(() => {
        if (isError && !itemState) {
            navigate(-1);
        }
    }, [isError]);
    (0, react_2.useEffect)(() => {
        if (data) {
            if (data === null || data === void 0 ? void 0 : data.success) {
                setItem(data === null || data === void 0 ? void 0 : data.data);
            }
            else {
                navigate(-1);
            }
        }
    }, [data]);
    return [item, isLoading, id, findByKey];
}
